import apiClient from '../../api/api_client';
import { loadingSlice } from './loading';

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getCsrfToken = async () => {
    const result = await apiClient.getCsrfToken();
    return result;
};

const postFeedback = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.postFeedback(payload);
    dispatch(loadingSlice.actions.unsetLoading());
    return result;
};

//actions that get exported to the views
export const feedbackActions = dispatch => {
    return {
        getCsrfToken: payload => getCsrfToken(),
        postFeedback: payload => postFeedback(dispatch, payload),
    };
};
